import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Forwards5 = () => (_jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" }, { children: [_jsx("path", { d: "M11 6h5V1h-1v3.16a8 8 0 1 0-1.34 9.5L13 13a7 7 0 1 1 1.3-8H11Z" }), _jsx("text", Object.assign({ transform: "translate(4.84 11.09)", style: {
                fontSize: 9,
                fontFamily: 'AktivGroteskGeberit-Regular,Aktiv Grotesk Geberit',
                letterSpacing: '-.1em',
            } }, { children: "5" }))] })));
export default Forwards5;
